<template>
    <div class="single-course-container">
        <div class="light-header-container">
            <div class="container">
                <div class="d-flex align-end justify-space-between">
                    <div class="light-header-content">
                        <div class="light-header-breadcrumbs">
                            <v-breadcrumbs :items="useritems" v-if="user">
                                <template v-slot:divider>
                                    <v-icon>mdi-chevron-right</v-icon>
                                </template>
                            </v-breadcrumbs>
                            <v-breadcrumbs :items="useritems" v-else>
                                <template v-slot:divider>
                                    <v-icon>mdi-chevron-right</v-icon>
                                </template>
                            </v-breadcrumbs>
                        </div>
                        <div class="light-header-title">
                            {{course.title}}
                        </div>
                        
                    </div>
                    <div class="light-header-btn-wrapper">
                        <div class="course-progress d-flex align-center justify-space-between">
                            <v-progress-linear
                                rounded 
                                color="red darken-2"
                                :value="Math.trunc(course.complete_percentage)"
                            ></v-progress-linear>

                            <span class="course-progress__text">
                                {{course.complete_percentage ? Math.trunc(course.complete_percentage) : 0}}% complete
                            </span>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
       <v-container>
           <div class="single-course-main single-course play sajilo-section pt-0">
               <div class="single-course-main-wrapper">
                    <div class="content-description">
                        <div v-if="videoURL">
                            <vimeoPlayer :url="videoURL" class="vimeo-video-wrapper">
                            </vimeoPlayer>
                        </div>
                        <template v-if="is_complete_subchapter === false || is_complete_subchapter === null">
                            <v-btn class="btn big_blue_button" :loading="loader" @click="completesubchapter()" style="max-width: 75%; display: block; margin: 20px auto 0;"><v-icon class="mr-2">mdi-check</v-icon> Mark as Complete</v-btn>
                        </template>
                    </div>
                    <div class="content-description show-mobile">
                        <div class="single-course-video-chapter">
                            <v-expansion-panels class="lecture" v-model="panel">
                                <v-expansion-panel expand v-for="(chapter, i) in chapterList" :key="i">
                                    <v-expansion-panel-header>
                                <div class="title d-flex">
                                    <template v-if="chapter.completed === true">
                                        <span>{{chapter.title}}</span>
                                        <div class="time" v-if="chapter.duration">
                                            <span class="status mr-0">
                                                <v-icon size="28">mdi-sticker-check</v-icon>
                                            </span>
                                            <v-icon v-if="chapter.duration">
                                                mdi-clock
                                            </v-icon>
                                            <span v-if="chapter.duration">{{chapter.duration}}</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <span>{{chapter.title}}</span>
                                        <div class="time" v-if="chapter.duration">
                                            <span class="status mr-0">
                                                <v-icon size="28">mdi-sticker-outline</v-icon>
                                            </span>
                                            <v-icon v-if="chapter.duration">
                                                mdi-clock
                                            </v-icon>
                                            <span v-if="chapter.duration">{{chapter.duration}}</span>
                                        </div>
                                    </template>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div v-for="(sc, i) in chapter.sub_chapter" :key="i">
                                    <template v-if="sc.completed === true">
                                        <button class="lecture__item complete" :class="sc.content_link === videoURL ? 'active': ''" @click="showNote(sc)">
                                            <span>{{sc.title}}</span>
                                            <div class="time">
                                                <span class="status">
                                                    <v-icon size="28">mdi-sticker-check</v-icon>
                                                </span>
                                                <span v-if="sc.duration">{{sc.duration}}</span>
                                                <v-icon v-if="sc.content_link === videoURL">mdi-play</v-icon>
                                            </div>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <button class="lecture__item" :class="sc.content_link === videoURL ? 'active': ''" @click="showNote(sc)">
                                            <span>{{sc.title}}</span>
                                            <div class="time">
                                                <span class="status">
                                                    <v-icon size="28">mdi-sticker-outline</v-icon>
                                                </span>
                                                <span v-if="sc.duration">{{sc.duration}}</span>
                                                <v-icon v-if="sc.content_link === videoURL">mdi-play</v-icon>
                                            </div>
                                        </button>
                                    </template>
                                </div>
                            </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </div>
                    </div>

                    <div class="light-header-menus mt-8">
                        <v-tabs
                        v-model="tab"
                        background-color="transparent"
                        class=""
                        color="red"
                        >
                            <v-tab>Overview</v-tab>
                            <v-tab v-if="subchapterintro">Chapter Summary</v-tab>
                            <v-tab>Notes</v-tab>
                        </v-tabs>
                    </div>
                    <v-divider></v-divider>

                    <v-tabs-items v-model="tab" class="mt-5">
                        <v-tab-item>
                            
                            <div class="content-title" v-if="course.what_you_will_learn">
                                What you will learn
                            </div>

                            <div class="content-description" v-if="course.what_you_will_learn">
                                <ul>
                                    <li v-for="(item, i) in keyLearningList" :key="i">{{ item.substring(2) }}</li>
                                </ul>
                            </div>

                            <div class="content-title" v-if="course.keyword">
                                Keywords
                            </div>

                            <div class="content-description" v-if="course.keyword">
                                <ul class="d-flex single-course__keyword">
                                    <li v-for="(key, i) in course.keyword" :key="i">
                                        <button class="single-course__keyword-item">{{key}}</button>
                                    </li>
                                </ul>
                            </div>
                        </v-tab-item>
                        <v-tab-item v-if="subchapterintro">
                            <template v-if="subchapterintro">
                                <div class="content-title">
                                    Lecture Summary
                                </div>
                                <div class="content-description">
                                    {{subchapterintro}}
                                </div>
                            </template>
                        </v-tab-item>
                        <v-tab-item>
                            <!-- <v-expansion-panels v-model="addNotePanel">
                                <v-expansion-panel>
                                    <v-expansion-panel-header>
                                        <span><v-icon>mdi-note-plus</v-icon> Create a new note.</span>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels> -->
                            <v-card class="grey lighten-5 px-2" elevation="1" rounded flat v-if="isActive">
                                <v-form class="mb-5 py-4 px-4">
                                    <v-card-title class="pl-0">Add Your Notes</v-card-title>
                                    <v-textarea
                                        v-model="formData.content"
                                        outlined
                                        name="note"
                                        dense
                                        placeholder="Leave your note here"
                                        value=""
                                    ></v-textarea>
                                    
                                    <v-btn
                                        color="primary-btn"
                                        large
                                        @click="addNote"
                                    >Add Note</v-btn>
                                </v-form>
                            </v-card>
                            <v-card flat class="transparent note mt-5" v-if="noteList">
                                <v-list>
                                    <v-list-item v-for="(note, i) in noteList" :key="i">
                                        <v-list-item-content>
                                            <div class="note__meta">
                                                <div>
                                                    <!-- <span class="mr-2">{{noteList.datetime_created.substring(10, '')}}</span> -->
                                                    <span class="mr-5"><v-icon color="primary">mdi-clock-outline</v-icon> {{note.datetime_created.substring(10, '')}}</span>
                                                    <span class=""><v-icon color="green mb-2 d-inline-block">mdi-book-open-page-variant</v-icon> {{note.subchapter.title}}</span>
                                                </div>
                                                <div>
                                                    <v-btn icon color="primary" small @click="openUpdateNote(note)"><v-icon>mdi-pencil</v-icon></v-btn>
                                                    <v-btn icon color="red"  small  @click="openDeleteNote(note)"><v-icon>mdi-delete</v-icon></v-btn>
                                                </div>
                                            </div>
                                            <div class="note__content py-5 px-4 grey rounded lighten-3">{{note.content}}</div>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                            <v-dialog v-model="notedialog" width="100%" max-width="700" persistent>
                                <v-card flat class="py-5 px-5">
                                    <v-card-title class="px-0">Update Note</v-card-title>
                                    <v-form>
                                        <!-- <v-text-field
                                            v-model="formData.id"
                                            outlined
                                            dense
                                            disabled
                                            label="Note ID"
                                        ></v-text-field> -->
                                        <v-textarea
                                            v-model="formData.content"
                                            outlined
                                            dense
                                            label="Note Content"
                                            placeholder="Leave your note here"
                                            value=""
                                        ></v-textarea>
                                        <!-- <v-text-field
                                            v-model="formData.subchapter"
                                            outlined
                                            dense
                                            disabled
                                            label="Subchapter ID"
                                        ></v-text-field> -->
                                    </v-form>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click="updateNote()">Update</v-btn>
                                        <v-btn @click="notedialog = false">Canel</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="dnotedialog" width="100%" max-width="700" persistent>
                                <v-card flat class="py-5 px-5">
                                    <v-card-title class="px-0">Are you sure you want to delete this note?</v-card-title>
                                    
                                    <v-card-actions>
                                        <v-btn color="red white--text" @click="deleteNote()">Delete</v-btn>
                                        <v-btn @click="dnotedialog = false">Canel</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-tab-item>
                    </v-tabs-items>

                    
               </div>
               <div class="single-course-sidebar hide-mobile">
                   <v-expansion-panels class="lecture" v-model="panel">
                        <v-expansion-panel expand v-for="(chapter, i) in chapterList" :key="i">
                            <v-expansion-panel-header>
                                <div class="title d-flex">
                                    <template v-if="chapter.completed === true">
                                        <span>{{chapter.title}}</span>
                                        <div class="time" v-if="chapter.duration">
                                            <span class="status mr-0">
                                                <v-icon size="28">mdi-sticker-check</v-icon>
                                            </span>
                                            <v-icon v-if="chapter.duration">
                                                mdi-clock
                                            </v-icon>
                                            <span v-if="chapter.duration">{{chapter.duration}}</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <span>{{chapter.title}}</span>
                                        <div class="time" v-if="chapter.duration">
                                            <span class="status mr-0">
                                                <v-icon size="28">mdi-sticker-outline</v-icon>
                                            </span>
                                            <v-icon v-if="chapter.duration">
                                                mdi-clock
                                            </v-icon>
                                            <span v-if="chapter.duration">{{chapter.duration}}</span>
                                        </div>
                                    </template>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div v-for="(sc, i) in chapter.sub_chapter" :key="i">
                                    <template v-if="sc.completed === true">
                                        <button class="lecture__item complete" :class="sc.content_link === videoURL ? 'active': ''" @click="showNote(sc)">
                                            <span>{{sc.title}}</span>
                                            <div class="time">
                                                <span class="status">
                                                    <v-icon size="28">mdi-sticker-check</v-icon>
                                                </span>
                                                <span v-if="sc.duration">{{sc.duration}}</span>
                                                <v-icon v-if="sc.content_link === videoURL">mdi-play</v-icon>
                                            </div>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <button class="lecture__item" :class="sc.content_link === videoURL ? 'active': ''" @click="showNote(sc)">
                                            <span>{{sc.title}}</span>
                                            <div class="time">
                                                <span class="status">
                                                    <v-icon size="28">mdi-sticker-outline</v-icon>
                                                </span>
                                                <span v-if="sc.duration">{{sc.duration}}</span>
                                                <v-icon v-if="sc.content_link === videoURL">mdi-play</v-icon>
                                            </div>
                                        </button>
                                    </template>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
               </div>
           </div>
       </v-container>
    </div>
</template>

<script>
  import vimeoPlayer from '@/components/vimeo/vimeo.vue'
  export default {
    data: () => ({
        name: 'MyCourseVideo',
        useritems: [
            {
            text: 'My Courses',
            disabled: false,
            href: '/mycourses',
            },
            {
            text: 'Python Course for All Beginners by Carl Baristonsy',
            disabled: true,
            href: '#',
            }
        ],
        course: [],
        chapterList: [],
        subChapterList: [],
        tab: null,
        user: null,
        videoID: null,
        videoURL: null,
        height: 500,
        // options: {
        //     muted: true,
        //     autoplay: true,
        // },
        playerReady: false,
        noteList: [],
        chId: "",
        notedialog: false,
        dnotedialog: false,
        formData: {},
        loader: false,
        // addNotePanel: [],
        panel: 0,
        isActive: false,
        subchapterId: null,
        subchapterintro: null,
        storeId: null,
        is_complete_subchapter: false,
        vsattus: null,
    }),
    components: {
        vimeoPlayer
    },
    methods: {
        onReady() {
			this.playerReady = true
		},
		play () {
			this.player.play()
		},
		pause () {
			this.player.pause()
		},

        async getCourse() {
            this.$bus.emit('loading-toggle');
            await this.$api.get(`course/course/`+this.$route.params.course_id).then(res => {
                this.course = res;
                if (res.what_you_will_learn !== null) {
                    this.keyLearningList = res.what_you_will_learn.split("\n");
                }
                this.useritems[1].text = res.title;
                this.lecturerInfo = res.lecturer;
                this.course.datetime_created = res.datetime_created.substring(10, '');
                this.getLecturesData(this.course.id);
                // this.getCourseId(this.course.id);
            })
            this.$bus.emit('loading-toggle');
        },

        async getLecturesData(id) {
            let url = '/course/chapter-list/'+id;
            await this.$api.get(url).then(async res => {
                this.chapterList = res;
                this.is_complete_subchapter = res[0].sub_chapter[0].completed
                this.storeSubChapterId(res[0].sub_chapter[0].id)
                this.videoURL = res[0].sub_chapter[0].content_link;
                this.subchapterintro = res[0].sub_chapter[0].introduction
                if(this.videoURL) {
                    this.isActive = true;
                    this.getNoteList(res[0].sub_chapter[0].id);
                }
                // console.log(this.videoURL)
            })
        },

        async getSubLecturesData(id) {
            let url = '/course/subchapter-list/'+id;
            await this.$api.get(url).then(res => {
                this.subChapterList = res;
                console.log(res)

            })
        },

        async addNote() {
            this.formData.subchapter = this.storeId
            let url = '/course/note/';
            await this.$api.post(url, this.formData);
            this.formData = {},
            this.getNoteList(this.storeId);
        },

        noteData(note) {
            this.formData.id = note.id;
            this.formData.content = note.content;
            this.formData.subchapter = note.subchapter.id;
        },

        showNote(ch) {
            this.getNoteList(ch.id)
            this.getvideoURL(ch.content_link);
            this.isActive = true;
            this.subchapterId = ch.id
            this.storeSubChapterId(ch.id)
            this.subchapterintro = ch.introduction
            this.isSubChComplete(ch);
            this.getSubLecturesid(ch.id)
        },

        getvideoURL(ch) {
            
            this.videoURL = ch
            this.$bus.emit('loading-toggle');
            
        },

        openUpdateNote(note) {
            this.noteData(note);
            this.notedialog = true;
        },

        openDeleteNote(note) {
            this.noteData(note);
            this.dnotedialog = true;
        },

        async updateNote() {
            let url = '/course/note/'+this.formData.id+'/';
            await this.$api.put(url, this.formData);
            this.getNoteList(this.formData.subchapter);
            this.formData = {};
            this.notedialog = false;
        },

        async deleteNote() {
            let url = '/course/note/'+this.formData.id+'/';
            await this.$api.delete(url, this.formData);
            this.getNoteList(this.formData.subchapter);
            this.formData = {};
            this.dnotedialog = false;
        },

        async getNoteList(id) {

            let url = '/course/note/?subchapter='+id;
            await this.$api.get(url).then(res => {
                this.noteList = res.results; 
                this.noteList.sort()
                this.noteList.reverse()
            })
        },

        async completesubchapter() {
            this.loader = true
            let payload = {
                is_completed: true,
                subchapter: this.storeId
            }
            await this.$api.post('course/subchapter-complete/', payload).then(res=> {
                if(res.is_completed === true) {
                    this.getCourse();
                }
                this.loader = false
            }).catch(err=>{
                if(err) {
                    this.loader = false
                }
            })
        },

        storeSubChapterId(id) {
            this.storeId = id;
        },

        getSubLecturesid(id) {
            this.getSubLecturesData(id);
        },

        getCourseId(id) {
            this.chId = id;
            // this.getNoteList(this.chId);
        },
        isSubChComplete(ch) {
            this.is_complete_subchapter = ch.completed
        }
    },
    
    async mounted () {
        this.getCourse();
        this.videoURL = this.getvideoURL(this.videoURL)
    },
  }
</script>

<style>
.light-header-container {
    background: #f3f2f480;
}
.light-header-container + .container {
    padding-top: 0;
    padding-bottom: 0px;
}
.light-header-container .container {
    padding-top: 0;
    padding-bottom: 30px;
}
/* Header Grid */
.light-header-content {
    flex: 1;
    max-width: 100%;
    margin-right: 2rem;
}
.light-header-btn-wrapper {
    padding: 2rem;
    flex-basis: 30%;
    max-width: 100%;
}
.course-progress {
    width: 100%;
    margin-bottom: 12px;
    font-size: 14px;
    font-family: var(--font-poppins);
}
.course-progress .v-progress-linear {
    width: 50%;
    margin-right: 20px;
}
/* Breadcrumbs */
.light-header-breadcrumbs .v-breadcrumbs {
    padding-left: 0 !important;
    font-size: 12px;
    font-family: var(--font-poppins);
    padding-top: 30px;
    padding-bottom: 0;
    margin-bottom: 19px;
}
.light-header-breadcrumbs .v-breadcrumbs a {
    color: var(--color-dark);
}
.light-header-title {
    font-size: 30px;
    font-weight: 500;
}
.single-course-main {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.single-course-main-wrapper {
    width: 70%;
    margin-right: 2rem;
    padding-top: 30px;
}
.single-course-sidebar {
    background: #F3F2F4;
    padding: 2rem;
    width: 30%;
    border-radius: 4px;
}
.single-course-sidebar-content {
    display: flex;
    justify-content: space-between;
    padding: 1rem 0;
    border-bottom: 1px solid #c4c4c4;
}
.single-course-sidebar-btn {
    padding-top: 2rem;
}
.content-title {
    color: var(--color-primary);
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 6px;
}

.content-description + * {
    margin-top: 30px;
}
.content-description > * {
    font-size: 14px;
    font-family: var(--font-poppins);
}
.content-description p {
    margin-bottom: 0;
}

.content-description p + p {
    margin-top: 4px;
}

.single-course-main .content-description ul {
    list-style: none;
    padding-left: 0;
}

.single-course-main .content-description ul li {
    padding-left: 20px;
    position: relative;
}

.single-course-main .content-description ul li + li {
    margin-top: 4px;
}

.single-course-main .content-description ul li:before {
    content: '-';
    position: absolute;
    left: 0;
    top: 0;
}

.dark--text {
    color: var(--color-dark);
}
</style>